import * as service from './discipline.service'
export default {
  props: ["action"], //FG - FOOF - After Cert - First Release Security (7) - added the prop
  data() {
    return {
      Disciplinecolumns: ['Date', 'Description', 'DisciplinaryAction', 'Actions'],
      optionstable: {

        headings: {
          DisciplinaryAction: 'Action',
          Description: 'Infraction',
          CorrectiveAction: 'Corrective Action',
          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },

        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['Name', 'Description', 'CorrectiveAction', 'Severity', 'Date'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',

        }

      },
      personalId: '',
      disciplines: [],
      DisciplineUsers: [],
      DisciplineForm: {
        Date: '',
        PersonnelId: '',
        Severity: '',
        Implication: '',
        Description: '',
        CorrectiveAction: '',
        TargetDate: '',
        CompletionDate: '',
        CompletionVerified: '',
        SupervisorComments: '',
        EmployeeComments: '',
        role: '',
        DisciplinedBy: '',
        DisciplinaryActionId: ''

      },
      disActions: ['Coaching', 'Warning', 'Verbal', 'Written', 'Suspension', 'Final', 'Termination'],
      editDiscipline: false,
      modalTitle: '',
      dispBackup: [],
      severity: [{
          value: 'Coaching',
          label: 'Coaching'
        }, {
          value: 'Warning',
          label: 'Warning'
        }, {
          value: 'Verbal',
          label: 'Verbal'
        }, {
          value: 'Written',
          label: 'Written'
        }, {
          value: 'Suspension',
          label: 'Suspension'
        }, {
          value: 'Final',
          label: 'Final'
        },
        {
          value: 'Termination',
          label: 'Termination'
        }
      ],

    }
  },

  mounted() {

    this.personelId = this.$route.params.id

    let context = this
    this.GetDisciplinedByUsers()
    //this.GetDisciplinaryActions()
    this.$router.app.$on('add_kudos', (data) => {

      context.DisciplineForm = {
        Date: '',
        PersonnelId: '',
        Severity: '',
        Implication: '',
        Description: '',
        CorrectiveAction: '',
        TargetDate: '',
        CompletionDate: '',
        CompletionVerified: '',
        SupervisorComments: '',
        EmployeeComments: '',
        role: '',
        DisciplinedBy: '',
        DisciplinaryActionId: ''

      }
      if (context.$refs['DisciplineForm']) {
        context.$refs['DisciplineForm'].resetFields()
      }

    })
    this.$router.app.$on('Discipline_obj', (data) => {

      context.GetDisciplineById(data)

    })
    this.$router.app.$on('submit_disci', (data) => {

      context.submitForm(data)

    })

    this.$router.app.$on('update_disci', (data) => {

      context.EditDiscipline(data)

    })
    this.$router.app.$on('del_disci', (data) => {

      context.del(data)

    })


  },

  beforeDestroy() {
    this.$root.$off('update_disci')
    this.$root.$off('del_disci')
    this.$root.$off('submit_disci')
    this.$root.$off('Discipline_obj')

  },

  methods: {

    GetDisciplinaryActions() {
      let context = this
      loader.startLoader()
      service.GetDisciplinaryActions().then(function (response) {

        if (response && response != null) {
          context.disActions = response

        } else {

          context.disActions = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetDisciplinedByUsers() {
      let context = this
      loader.startLoader()
      service.GetDisciplinedByUsers().then(function (response) {

        if (response && response != null) {
          context.DisciplineUsers = response

        } else {

          context.DisciplineUsers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    showDiscipline() {
      this.editDiscipline = false

      this.DisciplineForm = {
        Date: '',
        PersonnelId: '',
        Severity: '',
        Implication: '',
        Description: '',
        CorrectiveAction: '',
        TargetDate: '',
        CompletionDate: '',
        CompletionVerified: '',
        SupervisorComments: '',
        EmployeeComments: '',
        role: '',
        DisciplinedBy: '',
        DisciplinaryActionId: ''

      }
      this.resetForm('DisciplineForm')
      this.modalTitle = 'Create Discipline'

      $('#DForm').modal('show')

    },
    editcol(data) {
       //FG - FOOF - After Cert - First Release Security (7) - this method does not seem to be used
       alert("in editcol of discipline.controller.js - IS THIS USED???")
       if(buttonType=="view") 
         this.action="V";
       else
         this.action="E";
       alert(this.action) 
      this.editDiscipline = true
      $('#DForm').modal('show')

      this.modalTitle = 'Edit Discipline'
      this.DisciplineForm = deepcopy(data.row)
      this.DisciplineForm.Severity = parseInt(data.row.DisciplinaryActionId)

    },
    cancelpopup() {

      this.DisciplineForm = {}

    },
    GetDisciplineById(id) {
      let context = this

      service.GetDisciplineById(id).then(function (response) {
        context.DisciplineForm = response

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })

      })

    },

    submitForm(formName) {

      this.$refs[formName].validate((valid) => {

        if (valid) {

          let context = this
          loader.startLoader()

          if (this.DisciplineForm['Date']) {
            this.DisciplineForm['Date'] = this.$moment(this.DisciplineForm['Date']).format('MM-DD-YYYY')
          }
          if (this.DisciplineForm['TargetDate']) {
            this.DisciplineForm['TargetDate'] = this.$moment(this.DisciplineForm['TargetDate']).format('MM-DD-YYYY')
          }

          if (this.DisciplineForm['CompletionDate']) {
            this.DisciplineForm['CompletionDate'] = this.$moment(this.DisciplineForm['CompletionDate']).format('MM-DD-YYYY')
          }

          this.DisciplineForm['PersonnelId'] = this.personelId

          service.AddDiscipline(this.DisciplineForm).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
              loader.stopLoader()
              return;
            }

            context.$notify({
              title: 'Success',
              message: 'Successfully Created  Discipline',
              type: 'success'
            })

            context.$router.app.$emit('action_done')
            loader.stopLoader()


          }, (error) => {

            loader.stopLoader()

            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'DISCIPLINE -1 error while submit!!',

            type: 'error'

          })

          return false
        }
      })
    },

    del: function (data) {
      var ID = data
      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteDiscipline(ID).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
              loader.stopLoader()
              return;
            }

          if (context.personnelID) {
            context.GetDiscipline()
          }
          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

          context.$router.app.$emit('action_done')
        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    EditDiscipline(formName) {

      this.$refs[formName].validate((valid) => {

        if (valid) {

          let context = this
          loader.startLoader()

          if (context.DisciplineForm['Date']) {
            context.DisciplineForm['Date'] = context.$moment(context.DisciplineForm['Date']).format('MM-DD-YYYY')
          }
          if (context.DisciplineForm['TargetDate']) {
            this.DisciplineForm['TargetDate'] = context.$moment(context.DisciplineForm['TargetDate']).format('MM-DD-YYYY')
          }

          if (context.DisciplineForm['CompletionDate']) {
            context.DisciplineForm['CompletionDate'] = context.$moment(context.DisciplineForm['CompletionDate']).format('MM-DD-YYYY')
          }

          context.DisciplineForm['PersonnelId'] = context.personelId

          service.UpdateDiscipline(context.DisciplineForm).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
              loader.stopLoader()
              return;
            }

            loader.stopLoader()

            context.$notify({

              title: 'Success',

              message: 'Successfully Updated',

              type: 'success'

            })

            context.$router.app.$emit('action_done')

          }, (error) => {

            loader.stopLoader()

            context.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'DISCIPLINE - 2 error while submit!!',

            type: 'error'

          })

          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

  }

}



// WEBPACK FOOTER //
// ./src/components/discipline/discipline.controller.js